import { createReducer } from '@reduxjs/toolkit';

import { apologyDismissed, versionLoaded, statusLoaded, apologise } from '../thunks/apology.thunks';
import {
  layoutChanged,
  commandPaletteToggled,
  enableLiveUpdates,
  disableLiveUpdates,
} from '../thunks/global.thunks';

import { paymentMethodsLoaded } from '../thunks/payment-methods.thunks';

import type { GlobalsState } from '../../types/state.types';

const initialState: GlobalsState = {
  apologies: [],
  baseUrl: window.sesamBasename ? window.sesamBasename : '/',
  commandPaletteShown: undefined,
  layoutUpdates: 0,
  paymentMethodsLoaded: false,
  portalUrl: '/api',
  status: {},
  version: null,
  enableLiveUpdates: true,
};

/*
Note: We are using the builder callback for creating a typesafe reducer.
See https://redux-toolkit.js.org/usage/usage-with-typescript#building-type-safe-reducer-argument-objects
*/
export const globalsReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(apologyDismissed, (state, action) => {
      state.apologies = state.apologies.filter((a) => a.id !== action.payload);
    })
    .addCase(versionLoaded, (state, action) => {
      state.version = action.payload;
    })
    .addCase(statusLoaded, (state, action) => {
      state.status = action.payload;
    })
    .addCase(layoutChanged, (state) => {
      state.layoutUpdates += 1;
    })
    .addCase(apologise, (state, action) => {
      state.apologies.push(action.payload);
    })
    .addCase(paymentMethodsLoaded, (state) => {
      state.paymentMethodsLoaded = true;
    })
    .addCase(commandPaletteToggled, (state, action) => {
      if (state.commandPaletteShown === action.payload) {
        state.commandPaletteShown = undefined;
      } else {
        state.commandPaletteShown = action.payload;
      }
    })
    .addCase(enableLiveUpdates, (state) => {
      state.enableLiveUpdates = true;
    })
    .addCase(disableLiveUpdates, (state) => {
      state.enableLiveUpdates = false;
    })
);
